// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import { fileHandler } from '../../files'

export const downloadFiles = createAsyncThunk('package/downloadFiles', async (data) => {
  const files = {}
  const downloads = data
    .map(async ({ id, image }) => {
      files[`P${id}`] = image === '/product.png' ? image : await fileHandler.downloadFiles({ fileName: image, filePath: 'media/package/' })
    })
  await Promise.all(downloads)
  return files
})

export const getData = createAsyncThunk('package/getData', async (params, { dispatch }) => {
  const response = await axios.post('/package/pagelist', params)
  dispatch(downloadFiles(response?.data?.data?.allData || []))
  return response
})

export const getAllRecords = createAsyncThunk('package/getAllRecords', async () => {
  const response = await axios.post('/package/list')
  return response
})

export const createRecord = createAsyncThunk('packages/create', async (data, { dispatch }) => {
  const payload = {
    ...data,
    tax_id: data?.tax_id?.id,
    included: data?.included?.id,
    branch_id: data?.branch_id?.id
  }
  delete payload.validitydays
  const response = await axios.post('/package/create', payload)
  await dispatch(getData())
  return response
  // return { allData: response.data.allData, data: response.data.invoices, totalPages: response.data.total, params }
})


export const getBranch = createAsyncThunk('package/branch/list', async () => {
  const response = await axios.post('/branch/list')
  return response
})

export const getTaxes = createAsyncThunk('package/tax/list', async () => {
  const response = await axios.post('/tax/list')
  return response
})

export const deleteRow = createAsyncThunk('package/deleteRow', async ({ id }, { dispatch }) => {
  const response = await axios.post('/package/delete', { id })
  await dispatch(getData())
  return response
})

export const editRow = createAsyncThunk('package/editRow', async (data, { dispatch }) => {
  const payload = {
    ...data,
    tax_id: data?.tax_id?.id,
    included: data?.included?.id,
    branch_id: data?.branch_id?.id
  }
  delete payload.validitydays
  const response = await axios.post('/package/update', payload)
  await dispatch(getData())
  return response
})

export const datatablesSlice = createSlice({
  name: 'packages',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    message: null,
    loading: 'idle',
    BRANCH: [],
    TAX: [],
    VALIDITY: [
      { name_en: 'Daily', name_ar: 'يومي', id: 1 },
      { name_en: 'Weekly', name_ar: 'اسبوعي', id: 7 },
      { name_en: 'Monthly', name_ar: 'شهري', id: 30 },
      { name_en: 'QUATERLY', name_ar: 'ربع سنوي', id: 90 },
      { name_en: 'HALF YEARLY', name_ar: 'نصف سنوي', id: 180 },
      { name_en: 'YEARLY', name_ar: 'سنوي', id: 365 },
      { name_en: 'CUSTOM', name_ar: 'مخصص', id: 999 }
    ],
    TAX_TYPE: [
      { id: 1, name_en: 'Included', name_ar: "Included" },
      { id: 0, name_en: 'Excluded', name_ar: "Excluded" }
    ],
    PACKAGES: [],
    tableData: {
      allData: [],
      data: [],
      totalPages: 0,
      params: {}
    },
    files: {}
  },
  reducers: {
    clearMessage: (state) => {
      state.message = null
    }
  },
  extraReducers: builder => {
    builder
      .addCase(createRecord.pending, (state, action) => {
        if (state.loading === 'idle') {
          state.loading = 'pending'
          state.currentRequestId = action.meta.requestId
        }
      })
      .addCase(createRecord.fulfilled, (state, action) => {
        if (
          state.loading === 'pending' &&
          state.currentRequestId === action.meta.requestId
        ) {
          state.loading = 'idle'
          state.currentRequestId = undefined
          state.message = action.payload.data.message
        }
      })
      .addCase(createRecord.rejected, (state, action) => {
        if (
          state.loading === 'pending' &&
          state.currentRequestId === action.meta.requestId
        ) {
          state.loading = 'idle'
          state.message = action.payload.data.message
          state.currentRequestId = undefined
        }
      })
      .addCase(deleteRow.pending, (state, action) => {
        if (state.loading === 'idle') {
          state.loading = 'pending'
          state.currentRequestId = action.meta.requestId
        }
      })
      .addCase(deleteRow.fulfilled, (state, action) => {
        if (
          state.loading === 'pending' &&
          state.currentRequestId === action.meta.requestId
        ) {
          state.loading = 'idle'
          state.currentRequestId = undefined
          state.message = action?.payload?.data?.message
        }
      })
      .addCase(deleteRow.rejected, (state, action) => {
        if (
          state.loading === 'pending' &&
          state.currentRequestId === action.meta.requestId
        ) {
          state.loading = 'idle'
          state.message = action?.payload?.data?.message || strings.SOMETHING_WENT_WRONG_REDUCER
          state.currentRequestId = undefined
        }
      })
      .addCase(editRow.pending, (state, action) => {
        if (state.loading === 'idle') {
          state.loading = 'pending'
          state.currentRequestId = action.meta.requestId
        }
      })
      .addCase(editRow.fulfilled, (state, action) => {
        if (
          state.loading === 'pending' &&
          state.currentRequestId === action.meta.requestId
        ) {
          state.loading = 'idle'
          state.currentRequestId = undefined
          state.message = action?.payload?.data?.message
        }
      })
      .addCase(editRow.rejected, (state, action) => {
        if (
          state.loading === 'pending' &&
          state.currentRequestId === action.meta.requestId
        ) {
          state.loading = 'idle'
          state.message = action?.payload?.data?.message || strings.SOMETHING_WENT_WRONG_REDUCER
          state.currentRequestId = undefined
        }
      })
      .addCase(getBranch.fulfilled, (state, action) => {
        state.BRANCH = action?.payload?.data?.data || []
      })
      .addCase(getTaxes.fulfilled, (state, action) => {
        state.TAX = action?.payload?.data?.data || []
      })
      .addCase(getAllRecords.fulfilled, (state, action) => {
        state.PACKAGES = action?.payload?.data?.data || []
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.tableData = action?.payload?.data?.data || {}
      })
      .addCase(downloadFiles.fulfilled, (state, action) => {
        state.files = action?.payload || {}
      })
  }
})

export const actions = datatablesSlice.actions

export default datatablesSlice.reducer
